var _g, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.63,
    height: 18.124,
    viewBox: "0 0 15.63 18.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1955",
    "data-name": "Group 1955",
    transform: "translate(0.664 0.503)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 3.492,
    height: 13.378,
    transform: "matrix(0.878, 0.478, -0.478, 0.878, 6.407, 1.847)",
    fill: "#c06c84",
    stroke: "#c06c84",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5571",
    "data-name": "Path 5571",
    d: "M1159.913,2049.94l-1.875-1.013a.676.676,0,0,0-.922.272l-.816,1.5,3.069,1.663.816-1.5A.676.676,0,0,0,1159.913,2049.94Z",
    transform: "translate(-1149.906 -2048.843)",
    fill: "#c06c84",
    stroke: "#c06c84",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1652",
    "data-name": "Line 1652",
    x1: 1.995,
    y2: 3.658,
    transform: "translate(5.941 2.684)",
    fill: "#c06c84",
    stroke: "#c06c84",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5572",
    "data-name": "Path 5572",
    d: "M1114,2138.9l.136,3.507,2.933-1.844Z",
    transform: "translate(-1114 -2125.286)",
    fill: "#c06c84",
    stroke: "#c06c84",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_1653",
    "data-name": "Line 1653",
    x2: 14.255,
    transform: "translate(0.875 17.603)",
    fill: "#c06c84",
    stroke: "#c06c84",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/PencilIcon.2ecf7bfe82db3214021388342d6c9672.svg";
export { ForwardRef as ReactComponent };